import { useState } from 'react'
import emailjs from '@emailjs/browser';

const initialState = {
  name: '',
  email: '',
  message: '',
  subject:""
}


export const Contact = (props) => {
  const [{ name, email, message,subject }, setState] = useState(initialState)

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }
  const clearState = () => setState({ ...initialState })
 const  sendEmail=(e)=>{

        e.preventDefault();  // This is important, the email won't send without it
        emailjs
        .send(
            'service_oi0inoj',
            'template_x0mtvm3',
            {
                from_name: name,
                from_email: email,
                subject: subject,
                html_message: message,
            },
            {
                publicKey: '0ieAuUFopxSckloa6',
            }
        )
        .then(
            (result) => {
              console.log("result",result)
              setState({
                name:"",
                email:"",
                subject:"",
                message:"",
              })
                alert('Email sent!');
                //window.location.reload();  // This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
            },
            (error) => {
                console.log(error.text);
            }
        );
    };
  const handleSubmit = (e) => {
    alert.window('The function will be ready soon! right now we take a phone call on +250790137271. We apologize for that')
    e.preventDefault()
    //console.log(name, email, message)
    // emailjs
    //   .sendForm(
    //     'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID'
    //   )
    //   .then(
    //     (result) => {
    //       console.log(result.text)
    //       clearState()
    //     },
    //     (error) => {
    //       console.log(error.text)
    //     }
    //   )
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Get In Touch </h2>
                <p style={{fontSize:18,fontWeight:'bold'}}>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' validate onSubmit={sendEmail}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        value={name}
                        className='form-control'
                        placeholder='Name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        value={email}
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                 <div className='row'>
                    <div className='col-md-6'>
                       <div className='form-group'>
                      <input
                        type='text'
                        id='subject'
                        value={subject}
                        name='subject'
                        className='form-control'
                        placeholder='Subject'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                       </div>
                    <div className='col-md-6'> 
                       <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    value={message}
                    rows='4'
                    placeholder='Message'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                    </div>
                 </div>
               
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Address
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Phone
                </span>{' '}
                {props.data ? props.data.phone : 'loading'}<br/>
                {props.data ? props.data.phone2 : 'loading'}<br/>
                {props.data ? props.data.phone3 : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                {props.data ? props.data.email : 'loading'}
              </p>
            </div>
          </div>
          {/* <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                 
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2022  {' '}
            <a href='https://www.withallinone.com' rel='nofollow'>
            ALLINONE
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
